<script setup>
defineProps({
    manufacturer: { type: Object, required: true },
    zebraLogoUrl: { type: String, default: '' },
});

defineEmits(['click']);
</script>

<template>
  <div class="manufactor flex flex-col items-center" @click="$emit('click')">
    <div class="manufactor__header">
      <div class="w-full">
        <h2 class="text-center text-[15px] leading-[1.2] font-mono font-medium">{{ manufacturer.title }}</h2>
        <ul v-if="manufacturer.bus_sizes.length" class="manufactor__sizes flex gap-2 justify-center mt-2">
          <li
            v-for="s in manufacturer.bus_sizes"
            :key="s"
            :class="`bus-size bus-size--${s}`"
          ></li>
        </ul>
      </div>      
      
    </div>
    <div class="grow flex items-center justify-center w-full">
      <img
        v-if="manufacturer.logo"
        class="manufactor__logo"
        :src="manufacturer.logo"
        :style="manufacturer.logo_width ? `width:${manufacturer.logo_width}% !important` : ''"
      />
    </div>
    <img v-if="manufacturer.zebra_stamp" class="manufactor__header__zebra h-11 w-11 mx-auto" :src="zebraLogoUrl" />
  </div>
</template>
